import { FC } from "react";
import { useLocation } from "react-router-dom";

import styles from "./Haader.module.scss";

import { IsExaminationTag, Logout, Nav, ServerStatuses } from "@/components";
import { navLinks, pages } from "@/root/consts";
import { useAppSelector } from "@/hooks/redux";

const Header: FC = () => {
  const location = useLocation();
  const userType = useAppSelector((state) => state.userReducer.userType);

  if (
    location.pathname === pages.login.path ||
    location.pathname === pages.createUser.path
  ) {
    return null;
  }

  const navigation = navLinks.filter((link) =>
    link.path === pages.admin.path ? userType === "admin" : true
  );

  return (
    <header className={styles.header}>
      <Nav navLinks={navigation} />
      <ServerStatuses />
      <IsExaminationTag />
      <Logout />
    </header>
  );
};

export default Header;
